// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G3UZ","badges":"styles_badges__36BRT"};